<template>
  <div class="h-full">
    <ui-dropdown
      v-if="helpArticle"
      top
      right
      menu-class="w-96 -mt-4"
    >
      <template #toggle="{ toggle }">
        <div
          class="
            flex
            justify-center
            items-center
            py-1.5
            px-3
            h-full
            bg-indigo-500
            opacity-90
            hover:opacity-100
            cursor-pointer
          "
          @click="toggle"
        >
          <i class="mr-2 fas fa-question-circle" />
          Help
        </div>
      </template>
      <template #default="{ isVisible }">
        <div v-if="isVisible">
          <ui-modal-header
            :title="helpArticle.title"
            @dismiss="isModalVisible = false"
          />
          <div class="overflow-y-auto max-h-screen-75 scrollbar-thin scrollbar-thumb-gray-700 scrollbar-track-gray-800 scrollbar-thumb-rounded-full scrollbar-track-rounded-full">
            <div class="py-3 px-4 rich-text-content">
              <markdown
                :source="helpArticle.content || ''"
                class="text-sm text-gray-300"
              />
            </div>
            <iframe
              v-if="helpArticle.youtubeVideoId"
              class="w-full h-80"
              :src="`https://www.youtube.com/embed/${helpArticle.youtubeVideoId}`"
              title="YouTube video player"
              frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowfullscreen
            />
          </div>
          <div class="py-3 px-4 font-medium text-gray-200">
            <span class="opacity-80">Need more help?</span>
            <a
              href="#"
              class="text-indigo-500 hover:text-indigo-600"
            >Join our Discord!</a>
          </div>
        </div>
      </template>
    </ui-dropdown>
  </div>
</template>

<script>
import {
  defineComponent,
  computed,
} from "vue";
import { useQuery } from "@vue/apollo-composable";
import { useRoute } from "vue-router";
import viewHelpsQuery from "@/graphql/view-help/queries/viewHelps.query.gql";

import UiModal from "./ui/UiModal.vue";
import Markdown from "vue3-markdown-it"
import UiModalHeader from "./ui/UiModalHeader.vue";
import UiDropdown from "./ui/UiDropdown.vue";
import UiDropdownForm from "./ui/UiDropdownForm.vue";

export default defineComponent({
  components: {
    UiModal,
    Markdown,
    UiModalHeader,
    UiDropdown,
    UiDropdownForm,
  },
  setup() {
    const $route = useRoute();
    const {
      result: viewHelpsResult,
    } = useQuery(
      viewHelpsQuery,
      () => ({ routeName: $route.name, currentTab: $route.params?.currentTab }),
      () => ({ clientId: "cms", enabled: Boolean($route.name) }),
    );
    const viewHelps = computed(() => viewHelpsResult.value?.viewHelps);

    return {
      viewHelps,
    }
  },
  data() {
    return {
      isModalVisible: false,
    };
  },
  computed: {
    helpArticle() {
      return this.viewHelps?.[0] || null;
    },
  },
  methods: {
    show() {
      this.isModalVisible = true;
    },
  },
});
</script>

<style>
.rich-text-content {
  line-height: 1.35;
}
.rich-text-content h1,
.rich-text-content h2,
.rich-text-content h3,
.rich-text-content h4,
.rich-text-content h5,
.rich-text-content h6 {
  font-weight: 500;
  color: white;
  margin-bottom: 0.5rem;
}
.rich-text-content h1 {
  font-size: 3rem;
}
.rich-text-content h2 {
  font-size: 2rem;
}
.rich-text-content h3 {
  font-size: 1.5rem;
}
.rich-text-content h4 {
  font-size: 1rem;
}
.rich-text-content h5 {
  font-size: 0.875rem;
}
.rich-text-content h6 {
  font-size: 0.75rem;
}

.max-h-screen-75 {
  max-height: 65vh;
}
</style>